import React from 'react';

const MaterialIcon = ({ icon, className = '', ...props }) => {
  const classes = ['material-icons', className].filter(Boolean).join(' ');
  const finalProps = { ...props };

  if (!('aria-hidden' in finalProps) && !('aria-label' in finalProps) && !('aria-labelledby' in finalProps)) {
    finalProps['aria-hidden'] = 'true';
  }

  return (
    <span className={classes} {...finalProps}>
      {icon}
    </span>
  );
};

export default MaterialIcon;
